var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-medium scheme-color",class:{ 'border-right': _vm.lr, 'border-left': !_vm.lr },style:({ left: _vm.left })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }